// Sums the positive/negative procedure counts recorded on one or more
// location documents that fall within [from, to].
export function sumProceduresInRange(locations, from, to) {
  let positive = 0, negative = 0;
  if (!Array.isArray(locations)) return { positive, negative };
  locations.forEach((loc) => {
    const pc = loc?.procedureCount;
    if (!pc) return;
    Object.entries(pc).forEach(([year, months]) => {
      Object.entries(months).forEach(([month, days]) => {
        Object.entries(days).forEach(([day, counts]) => {
          // procedureCount months are 1-indexed; JS Date months are 0-indexed
          const ts = new Date(+year, +month - 1, +day).getTime();
          if (ts >= from && ts <= to) {
            positive += counts.positive || 0;
            negative += counts.negative || 0;
          }
        });
      });
    });
  });
  return { positive, negative };
}
